import {
  LAYOVER_AIRPORTS,
  LAYOVER_DURATION,
} from '@web-platform/shared-universal-constants/src/queryParams';
import { MINUTES_PER_HOUR } from '@web-platform/shared-universal-constants/src/timeDurations';
import { makeEntityId } from '@web-platform/shared-universal-types-utils/src/utils';
import {
  booleanKeyValuesParamParser,
  integerRangesParamParser,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/paramParsers';
import { parseParams } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/parseParams';
import { GLOBAL } from 'saddlebag-browser';

import { INITIAL_STATE } from '../layovers';

import type { LayoversFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/layovers';

export const getLayoversFromUrl = (): LayoversFilterState => {
  const globalWindow = GLOBAL.getWindow();
  if (!globalWindow?.location) return INITIAL_STATE;

  const params = parseParams();

  const durationRanges = integerRangesParamParser.deserialize(params[LAYOVER_DURATION]);
  const duration = durationRanges[0]
    ? {
        min: durationRanges[0].start / MINUTES_PER_HOUR,
        max: durationRanges[0].end / MINUTES_PER_HOUR,
      }
    : INITIAL_STATE.duration;

  const airportEntries = booleanKeyValuesParamParser.deserialize(params[LAYOVER_AIRPORTS]);
  const excludedAirports = airportEntries.filter((e) => !e.value).map((e) => makeEntityId(e.key));

  return { duration, excludedAirports };
};
